import type { ShadowComparison } from "../core/comparison.js";
import type { ComparisonSection } from "./types.js";
import { renderComparisonChart } from "./eratosthenes-chart.js";
import { renderComparisonTable } from "./eratosthenes-table.js";

/** Adapte les résultats du domaine en contenu déjà échappé pour la page commune. */
export function shadowComparisonSection(comparison: ShadowComparison): ComparisonSection {
  return comparison.ok
    ? { kind: "available", chart: renderComparisonChart(comparison), table: renderComparisonTable(comparison) }
    : { kind: "unavailable", reasons: comparison.reasons };
}
